import styled from 'styled-components';
export const CollapseWrapper = styled.div`
  display: grid;
  grid-template-rows: ${({
  $isOpen
}) => $isOpen ? '1fr' : '0fr'};
  transition: grid-template-rows 250ms ease-in;

  & > div {
    overflow: hidden;
    opacity: ${({
  $isOpen
}) => $isOpen ? 1 : 0};
    transition: opacity 250ms ease-in;
  }
`;
//# sourceMappingURL=styles.js.map